import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {PopoverDirective} from 'ngx-bootstrap/popover';
import {takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../../destroyable.component';

@Component({
  selector: 'gp-hr-calendar-header',
  templateUrl: './hr-calendar-header.component.html',
  styleUrls: ['./hr-calendar-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HrCalendarHeaderComponent extends Destroyable implements OnInit, OnChanges {

  @Input()
  public viewDate: Date;

  @Output()
  public previous: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public next: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public monthSelected: EventEmitter<Date> = new EventEmitter<Date>();

  @ViewChild('monthPopover')
  public monthPopover: PopoverDirective;

  public monthLabel = '';
  public isPickerOpen = false;

  constructor(private translate: TranslateService,
              private cd: ChangeDetectorRef) {
    super();
  }

  public ngOnInit(): void {
    this.translate.onLangChange.pipe(
      tap(() => {
        this.updateLabel();
        this.cd.markForCheck();
      }),
      takeUntil(this.componentDestroyed$)
    ).subscribe();
  }

  public ngOnChanges(): void {
    this.updateLabel();
  }

  public setPickerOpen(isOpen: boolean): void {
    this.isPickerOpen = isOpen;
    this.cd.markForCheck();
  }

  public closePicker(): void {
    this.monthPopover?.hide();
  }

  public onMonthSelected(date: Date): void {
    this.closePicker();
    this.monthSelected.emit(date);
  }

  private updateLabel(): void {
    this.monthLabel = this.viewDate ? moment(this.viewDate).format('MMMM YYYY') : '';
  }
}
